import ReactCountryFlag from "react-country-flag";

export const renderCountryFlag = ({ value }) => (
  <ReactCountryFlag svg countryCode={value} style={{ width: "100%" }} />
);
